// removed by extract-text-webpack-plugin
module.exports = {"disclaimer":"af5bSLsqIm text mix-text_small","left-align-disclaimer":"_3QNSv7X0gH text mix-text_small"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/forms/secure/PayNowForm/Disclaimer/Disclaimer.module.less
// module id = 989
// module chunks = 3